import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

// prettier-ignore
import { StructuredListWrapper, StructuredListHead, StructuredListBody, StructuredListRow, StructuredListCell } from '@carbon/react';

import { Html } from 'components';
import * as css from './ServersLocations.module.scss';

type Translations = Record<string | 'en', string>;
export type ServerLocation = {
    label: Translations;
    where?: Translations;
    urls: string[];
};
export type ServersLocationsProps = { data: ServerLocation[] };

export function ServersLocations({ data }: ServersLocationsProps) {
    const intl = useIntl();
    const getLabel = (loc: ServerLocation) => loc.label[intl.locale] || loc.label.en;
    const getWhere = (loc: ServerLocation) => loc.where?.[intl.locale] || loc.where?.en;

    const header: ReactNode = (
        <StructuredListRow head>
            <StructuredListCell head children={intl.formatMessage({ defaultMessage: "Servers' Location" })} />
            <StructuredListCell head children={intl.formatMessage({ defaultMessage: 'URL' })} />
        </StructuredListRow>
    );

    const body = data.map((loc, ind) => {
        const urls = loc.urls;
        const label = getLabel(loc);
        const where = getWhere(loc);

        return (
            <StructuredListRow key={ind}>
                <StructuredListCell noWrap>
                    <Html children={label} container="strong" />
                    {where ? <Fragment>,&nbsp;{where}</Fragment> : null}
                </StructuredListCell>
                <StructuredListCell
                    children={urls.map(url => (
                        <span key={url} children={url} className={css.url} />
                    ))}
                />
            </StructuredListRow>
        );
    });

    return (
        <div className={css.root} dir="ltr">
            <StructuredListWrapper isCondensed isFlush selection>
                <StructuredListHead children={header as any} />
                <StructuredListBody children={body} />
            </StructuredListWrapper>
        </div>
    );
}
